import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getUserProfile = createAsyncThunk(
  "Setting/getUserProfile",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/me/profile`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  "Setting/updateUserProfile",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/me/profile/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getSetting = createAsyncThunk(
  "Setting/getSetting",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/settings`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const addSetting = createAsyncThunk(
  "Setting/addSetting",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/admin/settings`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateSetting = createAsyncThunk(
  "Setting/updateSetting",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/settings/${data.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonDT")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
// deleteSetting
export const deleteSetting = createAsyncThunk(
  "Setting/deleteSetting",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/admin/settings/${id}`,

          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonDT")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
const SettingsSlice = createSlice({
  name: "Setting",
  initialState: {
    isSettingLoading: false,
    error: null,
    ProfileSettingArray: null,
    SettingArray: null,
  },
  extraReducers: (builder) => {
    builder
      // getUserProfile
      .addCase(getUserProfile.pending, (state) => {
        state.isSettingLoading = true;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.isSettingLoading = false;
        state.ProfileSettingArray = action.payload.data;
      })
      .addCase(getUserProfile.rejected, (state, action) => {
        state.isSettingLoading = false;
      })
      // updateUserProfile
      .addCase(updateUserProfile.pending, (state) => {
        state.isSettingLoading = true;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.isSettingLoading = false;
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.isSettingLoading = false;
      })

      // getSetting
      .addCase(getSetting.pending, (state) => {
        state.isSettingLoading = true;
      })
      .addCase(getSetting.fulfilled, (state, action) => {
        state.isSettingLoading = false;
        state.SettingArray = action.payload.data;
      })
      .addCase(getSetting.rejected, (state, action) => {
        state.isSettingLoading = false;
      })
      .addCase(addSetting.pending, (state) => {
        state.isSettingLoading = true;
      })
      .addCase(addSetting.fulfilled, (state, action) => {
        state.isSettingLoading = false;
      })
      .addCase(addSetting.rejected, (state, action) => {
        state.isSettingLoading = false;
      })
      .addCase(updateSetting.pending, (state) => {
        state.isSettingLoading = true;
      })
      .addCase(updateSetting.fulfilled, (state, action) => {
        state.isSettingLoading = false;
      })
      .addCase(updateSetting.rejected, (state, action) => {
        state.isSettingLoading = false;
      })
      .addCase(deleteSetting.pending, (state) => {
        state.isSettingLoading = true;
      })
      .addCase(deleteSetting.fulfilled, (state, action) => {
        state.isSettingLoading = false;
        state.SettingArray = state.SettingArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteSetting.rejected, (state, action) => {
        state.isSettingLoading = false;
      });
  },
});

export default SettingsSlice.reducer;
